/** InsCoder WANG.J 2026-07-21 B + Accessible single-open behavior for community FAQ. **/
(() => {
  const state = window.__custFaqV3State || (window.__custFaqV3State = { initializedSections: new WeakSet() });

  const bindFaqSections = (root) => {
    const sections = root.matches?.('[data-faq-section]')
      ? [root]
      : [...(root.querySelectorAll?.('[data-faq-section]') || [])];

    sections.forEach((section) => {
      if (state.initializedSections.has(section)) return;
      state.initializedSections.add(section);

      section.querySelectorAll('details').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          section.querySelectorAll('details[open]').forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  };

  bindFaqSections(document);
  if (!state.listenerBound) {
    document.addEventListener('shopify:section:load', (event) => bindFaqSections(event.target));
    state.listenerBound = true;
  }
})();
/** InsCoder WANG.J 2026-07-21 E + Accessible single-open behavior for community FAQ. **/
